import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";

import { nav } from "./navigation";

export default function App() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.userReducer);

  useEffect(() => {
    if (isAuthenticated) {
      if (user?.role === "student" && user?.firstAccess) {
        navigate("/manage-account");
      } else {
        if (window?.location?.pathname === "/") navigate("/home");
      }
    } else {
      if (
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/checkout" &&
        window.location.pathname !== "/forget-pass" &&
        window.location.pathname !== "/signup-affiliate" &&
        window.location.pathname !== "/calendar/oauth/google/callback"
      ) {
        navigate("/login");
      }
    }
    // eslint-disable-next-line
  }, [isAuthenticated]);

  return (
    <Routes>
      {nav
        .filter((r) => r.isPrivate === isAuthenticated)
        .map((r, i) => {
          return <Route key={i} path={r.path} element={r.element} />;
        })}
    </Routes>
  );
}
